<template>
  <div class="service-list-wrapper">
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 使用 Vant Grid 组件布局 -->
    <van-grid :border="false" :column-num="3">
      <van-grid-item v-for="(item, index) in datas.imageList" :key="index">
        <div
          class="service-card-wrapper"
          :style="{
            backgroundImage: `url(${item.src})`,
            border: `1px solid ${item.borderColor}`,
          }"
          @click="handleNavigationClick({ index, item })"
        >
          <h3
            class="service-card-title"
            :style="{
              color: item.textColor,
              fontSize: item.textSize + 'px',
            }"
          >
            {{ item.text }}
          </h3>
          <span
            class="sub-text"
            :style="{
              color: item.textColor,
              fontSize: item.subFontSize + 'px',
            }"
            >{{ item.subText }}</span
          >
          <div class="line" :style="{ backgroundColor: item.lineColor }"></div>
        </div>
      </van-grid-item>
    </van-grid>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
// 按需引入时取消注释（全局引入Vant则无需此步骤）
// import { VanGrid, VanGridItem } from 'vant';

export default {
  name: "servicenavigation",
  // 按需引入时注册组件
  // components: {
  //   VanGrid,
  //   VanGridItem
  // },
  props: {
    datas: Object,
    isShow: Boolean,
  },
  data() {
    return {};
  },
  created() {
    console.log(
      "servicenavigation子组件挂载了--------------------111-1-1-1-1-1--1",
      this.datas,
    );
  },
  methods: {
    // 处理点击事件，例如触发父组件的事件或更新数据
    handleNavigationClick(params) {
      this.$emit("navigation-click", params);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.van-grid {
  .van-grid-item {
    .van-grid-item__content {
      padding: 0px !important;
    }
  }
}
// 外层容器保留原有宽度和盒模型设置
.service-list-wrapper {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 5px;
}
.line {
  width: 26px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  margin-top: 10px;
}
.service-card-wrapper {
  border-radius: 5px;
  background-size: cover;
  background-repeat: no-repeat;
  height: 107px;
  display: flex;
  flex-direction: column;
  padding: 5px 0 0 5px;
  width: 96%;
}
.service-card-title {
  margin-bottom: 5px;
}
</style>
